/**
 * Quilty brand-architecture verticals (QUI brand lockup system).
 *
 * Single source of truth for the branded-house lockup: the master Quilty
 * logo never changes, while the vertical name underneath differentiates each
 * product line. Color is applied ONLY to the vertical name, never to the
 * master logo or the divider. See docs/brand/BRAND_LOCKUP.md.
 */

export type Vertical = 'film-tv' | 'music' | 'social';

export interface VerticalSpec {
  /** Uppercase display label shown under the master logo. */
  label: string;
  /** Accent hex applied to the vertical name only. Matches app.css tokens. */
  color: string;
}

export const VERTICALS: Record<Vertical, VerticalSpec> = {
  'film-tv': { label: 'FILM & TV', color: '#7A1C27' },
  music: { label: 'MUSIC', color: '#205C3B' },
  social: { label: 'SOCIAL', color: '#4A1F6E' },
};

/** The anchor vertical used site-wide until Music and Social launch. */
export const DEFAULT_VERTICAL: Vertical = 'film-tv';
